
import { defineComponent, computed } from 'vue';

interface BreadcrumbItem {
  title: string;
  url: string;
}

export default defineComponent({
  name: 'Breadcrumbs',
  props: {
    items: {
      type: Array as () => BreadcrumbItem[],
      required: true,
    },
    isSearchPage: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const breadcrumbs = computed(() =>
      props.items.map((item) => ({
        text: item.title,
        to: { path: item.url },
      }))
    );

    return {
      breadcrumbs,
    };
  },
});
